import type { FeatureCollection } from "geojson";
import fairburnBoundaryData from "./data/fairburn-boundary.json";
import atlantaBoundaryData from "./data/atlanta-boundary.json";

export const fairburnBoundary = fairburnBoundaryData as unknown as FeatureCollection;
export const atlantaBoundary = atlantaBoundaryData as unknown as FeatureCollection;

const organizationGeoJsonBoundaries: Readonly<Record<string, FeatureCollection>> = {
  "7adc585d-5b70-48bb-9aff-a644b38b9894": fairburnBoundary,
  "25594f98-3ac4-4d9b-926a-6f3256b868fc": atlantaBoundary,
};

export const getOrganizationGeoJsonBoundary = (organizationId?: string): FeatureCollection | undefined =>
  organizationId ? organizationGeoJsonBoundaries[organizationId.toLowerCase()] : undefined;

export const getUserGeoJsonBoundary = getOrganizationGeoJsonBoundary;
